export const version = VERSION;



// WEBPACK FOOTER //
// ./src/version.ts